import { hydrateRoot } from "react-dom/client";
import App from "../app";

const { storeData } = window.asos.oa.state;
delete window.asos.oa.state;

hydrateRoot(
  document.getElementById("react-root"),
  <App storeData={storeData} />
);
